module.exports = __webpack_public_path__ + "static/media/b3_p4_clickable_ph.af7e9bee.png";